import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewContainerRef } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LCS_SINGLE_SELECT_OPTIONS, LcsSingleSelectBase } from '../../single-select/single-select-base';
import { DayOfWeekOption } from '../models/day-of-week-option';
import { dayOfWeekOptionSelectors } from '../state/day-of-week-option.reducer';

@Component({
    providers: [
        {
            provide: LCS_SINGLE_SELECT_OPTIONS,
            useExisting: DayOfWeekSelectComponent,
        },
    ],
    selector: 'ndt-day-of-week-select',
    templateUrl: './day-of-week-select.component.html',
    standalone: false
})
export class DayOfWeekSelectComponent extends LcsSingleSelectBase<DayOfWeekOption> implements OnInit {
   daysOfWeek: Observable<DayOfWeekOption[] | null>;

   private readonly daysOfTheWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

   constructor(
      protected elementRef: ElementRef,
      protected changeDetectorRef: ChangeDetectorRef,
      protected viewContainerRef: ViewContainerRef,
      private store: Store
   ) {
      super(elementRef, changeDetectorRef, viewContainerRef);
   }

   ngOnInit(): void {
      this.daysOfWeek = this.store.pipe(
         select(dayOfWeekOptionSelectors.selectFilteredItems),
         this.itemsLoaded(),
         map((items: Array<DayOfWeekOption>) => {
            if (items) {
               return items.sort((a, b) => {
                  const dayA = a.dayOfWeek || '';
                  const dayB = b.dayOfWeek || '';
                  const indexA = this.daysOfTheWeek.indexOf(dayA);
                  const indexB = this.daysOfTheWeek.indexOf(dayB);
                  return indexA - indexB;
               });
            }
            return null;
         })
      );
   }

   displayWith(item: DayOfWeekOption | null): string | null {
      return item ? item.dayOfWeek : null;
   }

   trackBy(item: DayOfWeekOption | null) {
      return item ? item.dayOfWeek : null;
   }
}
